export const SET_BETBAR_PARENT = "betbarParent:SET_BETBAR_PARENT";

export const setBetbarParent = (payload) => (dispatch) => {
  dispatch({
    type: SET_BETBAR_PARENT,
    payload,
  });
};
